"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("../utils");
var _processRichText = _interopRequireDefault(require("../utils/process-rich-text"));
var _standard = _interopRequireDefault(require("../utils/rich-text-factories/standard"));
var _image = _interopRequireDefault(require("./image"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var createJourneyProduct = function createJourneyProduct(data) {
  var document = (0, _utils.getProp)(data, 'details');
  var details = document ? (0, _processRichText["default"])({
    document: document,
    factories: _standard["default"]
  }) : null;
  var priceData = (0, _utils.getProp)(data, 'price') || {};
  var price = priceData[process.env.NEXT_PUBLIC_SITE] || null;
  return {
    productId: (0, _utils.getProp)(data, 'identifier'),
    productName: (0, _utils.getProp)(data, 'name'),
    identifier: (0, _utils.getProp)(data, 'identifier'),
    byline: (0, _utils.getProp)(data, 'byline'),
    contentSummary: (0, _utils.getProp)(data, 'contentSummary'),
    motif: (0, _utils.getProp)(data, 'motif'),
    image: (0, _utils.getProp)(data, 'image') ? (0, _image["default"])(data.image) : null,
    keyFeatures: (0, _utils.getProp)(data, 'keyFeatures'),
    optionsAvailableSeparately: (0, _utils.getProp)(data, 'optionsAvailableSeparately'),
    optionsLabel: (0, _utils.getProp)(data, 'optionsLabel'),
    options: (0, _utils.getProp)(data, 'options'),
    details: details,
    price: price,
    isExtra: (0, _utils.getProp)(data, 'isExtra'),
    mutuallyExclusive: (0, _utils.getProp)(data, 'mutuallyExclusive', false)
  };
};
var _default = createJourneyProduct;
exports["default"] = _default;